const doc = [({"ja":({"adminConstantHotelChildrenSettingMealType":({"sameAsAdult":"大人と同じ", "included":"子供の食事", "notIncluded":"なし"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;